export const BASE_URL = "https://www.tasr.sk/volby2026";

export function formatNumber(n: number | undefined | null): string {
  if (n === undefined || n === null || isNaN(n as number)) return "0";
  return Number(n).toLocaleString("sk-SK");
}

export function formatPercent(n: number | undefined | null): string {
  if (n === undefined || n === null || isNaN(n as number)) return "0 %";
  return Number(n).toLocaleString("sk-SK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " %";
}

export function normalizeSearchText(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

export type CandidateStatus = "elected" | "substitute" | "tie" | null;

export function statusLabel(status: CandidateStatus, final: boolean): string {
  if (status === "elected") return final ? "zvolený" : "vedie";
  if (status === "substitute") return "náhradník";
  if (status === "tie") return "rozhodne žreb";
  return "";
}
